
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and
// compiles into the necessary css files
import style from '../scss/index.scss';

import "./app";

// Inject our components
require('./components/content-video-embeds.js');
require('./components/critical-notice.js');
require('./components/inline-links-element.js');
require('./components/elemental-testimonial-slider.js');
require("./components/responsive-table-display.js");

require("./utils/accessible-link.js");